module.exports = __webpack_public_path__ + "/login_ui/img/tj-dc1a2e8e84ace99805da63f5839201f8.svg";